<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="m-newDetail">
			<div class="detail_cont">
				<div>
					<img class="list_img" :src="zidiyiData.news_center.files" />
				</div>
				<div class="cont_info">
					<el-row :gutter="30">
						<el-col :span="19">
							<div class="info_left">
								<div class="left_tit">{{lang=='CN' ?content.cn_title:content.en_title}}</div>
								<div class="left_time_look">
									<span class="commo_span">{{content.publishtime_text}}</span>
									<span class="commo_span">
										<img src="@/assets/news/eye.svg" :alt="content.seo2" />
										<span>{{content.view}}</span>
									</span>
									<span class="commo_span">
										<img src="@/assets/news/comment.svg" :alt="content.seo3" />
										<span>{{content.comment_num}}</span>
									</span>
								</div>

								<!--直播配图 GO-->
								<div class="live" @click="goOutlink(content.outlink)">
									<div class="photo"><img :src="content.image" :alt="content.seo1" /></div>
									<div class="qrcode">
										<img :src="content.ewm" :alt="content.en_digest">
									</div>
								</div>


								<!--通用头部 GO-->
								<div class="commo_tit">
									<div class="tit_left">
										<span>直播介绍</span>
										<el-divider direction="vertical"></el-divider>
										<span>INTRODUCE</span>
									</div>

								</div>


								<div class="info_detail" v-html="lang=='CN' ?content.cn_content:content.en_content">
								</div>

								<div class="btn-bottom">
									<span>直播间链接：</span>
									<div class="go" @click="goOutlink(content.outlink)">进入直播间</div>
									<div class="copy" @click="copy" :data-clipboard-text="content.outlink"
										id="express_info_right">复制链接</div>
									<div class="link">{{content.outlink}}</div>


								</div>


							</div>
						</el-col>


						<el-col :span="5">
							<div class="info_right">
								<div class="right_tit text-uppercase">{{lang=='CN' ?'热点聚焦':'hot topic'}}</div>
								<div class="right_info">
									<div class="wrap" v-for="(item,index) in arcList" v-if="index<3">
										<div class="youDetail" v-if="index==0">
											<img :src="item.image" />
											<span>{{item.author}}</span>
										</div>
										<div class="youDetailList" @click.stop="detail(item.id)">
											<span class="tit_span">{{lang=='CN' ?item.cn_title:item.en_title}}</span>
											<div class="goDetailBtn">
												<span>{{item.publishtime_text}}</span>
												<span
													class="btn_square css3"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
											</div>
										</div>
									</div>
									<div class="more_btn btn_square" @click.stop="go_hotList">
										<em data-v-957c9522="">查看更多 MOER</em><span data-v-957c9522=""></span>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>



		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import moment from 'moment'

	import Header from '@/components/Header'
	import Footer from '@/components/Footer'

	export default {
		components: {
			Header,
			Footer
		},
		name: 'new_detail',
		data() {
			return {
				textarea: '',
				id: '',
				content: {},
				arcList: [],
				total: '',
				company_id: 1, //公司ID
				commentList: [],
				per_page: 9,
				page: 1,
				zidiyiData: {
					news_center: {
						files: ''
					}
				},
				comTotal: '',
				comList: [],
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		filters: {
			formatDate: function(value) {
				return moment(value * 1000).format('YYYY-MM-DD')
			}
		},

		created() {
			this.id = this.$route.query.id
			this.company_id = this.$route.query.id
			this.detail(this.id)
			this.getZidiyiData();
			this.getCommentList()
			let data = {
				channel_id: '',
				per_page: this.per_page,
				page: this.page,
				flag: 'hot'
			}

			this.$axios.get("/api/jx/archives_list", {
				params: data
			}).then((res) => {

				if (res.data.code == 1) {
					this.arcList = res.data.data.data
					this.total = res.data.data.total
				}
			}).catch(err => {});
			this.addLocatPath()
		},
		mounted() {
			this.id = this.$route.query.id
			this.company_id = this.$route.query.id
			this.detail(this.id)
			this.getZidiyiData();
			this.getCommentList()
			let data = {
				channel_id: '',
				per_page: this.per_page,
				page: this.page,
				flag: 'hot'
			}

			this.$axios.get("/api/jx/archives_list", {
				params: data
			}).then((res) => {

				if (res.data.code == 1) {
					this.arcList = res.data.data.data
					this.total = res.data.data.total
				}
			}).catch(err => {});
			this.addLocatPath()
		},
		created() {
			this.getNotice()
		},
		methods: {


			copy() {
				let clipboard = new this.clipboard("#express_info_right");
				let that = this
				clipboard.on('success', function() {
					that.$message.success('复制成功');
					clipboard.destroy();
				});
				clipboard.on('error', function() {
					that.$message.error('复制失败');
				});
			},

			goOutlink(url) {
				window.open(url, "_blank");
			},


			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			detail(id) {
				let data = {
					id: id
				}
				this.$axios.get("/api/jx/archives_detail", {
					params: data
				}).then((res) => {
					if (res.data.code == 1) {
						this.content = res.data.data

					}
				}).catch(err => {});
			},
			send() {
				this.push()
			},
			addLocatPath() {
				let data = {
					directions: '新闻详情',
					path: window.location.href
				}

				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {

				}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}

				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data
				}).catch(err => {});
			},
			push() {
				let data = {
					archives_id: this.id,
					comment: this.textarea
				}
				this.$axios.get("/api/jx/add_comment", {
					params: data
				}).then((res) => {

					if (res.data.code == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.textarea = ''
						this.getCommentList()
					} else {
						this.$message.error(res.data.msg);
					}
				}).catch(err => {});
			},
			getCommentList() {
				let data = {
					archives_id: this.company_id,
					per_page: this.per_page,
					page: this.page
				}
				this.$axios.get("/api/jx/comment_list", {
					params: data
				}).then((res) => {


					this.comTotal = res.data.data.total
					this.comList = res.data.data.data
				}).catch(err => {});
			},
			go_hotList() {
				this.$router.push({
					path: `hot`
				})

			},

		}
	}
</script>

<style lang="scss" scoped>
	.m-newDetail {
		background: #fff;
	}

	.m-newDetail .detail_cont {
		padding: 30px;
	}

	.m-newDetail .detail_cont .detail_img {
		width: 100%;
	}

	.m-newDetail .cont_info {
		margin: 50px auto;
		width: 1400px;
	}

	.m-newDetail .left_tit {
		font-size: 28px;
		font-weight: bold;
	}

	.m-newDetail .left_time_look {
		margin-top: 30px;
	}

	.m-newDetail .left_time_look img {
		width: 20px;
	}

	.m-newDetail .commo_span {
		margin-right: 50px;

		span {
			margin-left: 5px;
		}
	}

	.m-newDetail .info_detail {
		margin-top: 50px;
	}

	.info_detail>>>img {
		width: 100%;
	}

	.m-newDetail .share {
		margin-top: 60px;
	}

	.m-newDetail .share img {
		width: 30px;
		height: 30px;
		margin-right: 20px;
	}

	.m-newDetail .share span {
		margin-right: 20px;
	}

	.m-newDetail .shuru_input {
		display: flex;
		margin-top: 60px;
	}

	.el-textarea {
		display: inherit;
	}

	.el-textarea__inner {
		min-height: 100px !important;
	}


	.live {
		// width: 1080px;
		height: 420px;
		margin: 60px auto 0;

		.photo {
			width: 800px;
			height: 420px;
			float: left;
			cursor: pointer;

			img {

				object-fit: cover;
			}
		}

		.qrcode {
			width: 280px;
			height: 420px;
			float: left;
			background: url(../../assets/img/live.png);
			text-align: center;

			img {
				margin: 140px auto;
				width: 180px;
				height: 180px;
				object-fit: cover;
			}
		}


	}



	/* 通用头部 GO*/
	.commo_tit {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 60px;
	}



	.commo_tit .tit_left span:first-child {
		font-size: 30px;
		color: #000;
		font-weight: bold;
	}

	.commo_tit .el-divider--vertical {
		margin: 0 8px !important;
	}

	.commo_tit .el-divider {
		background-color: #000;
	}

	.commo_tit .tit_right {
		display: flex;
		align-items: center;
		color: #000;
	}

	.btn-bottom {
		overflow: hidden;
		margin-top: 50px;

		span {
			float: left;
			line-height: 26px;
			color: #000000;
			font-size: 24px;
		}

		.go {
			width: 122px;
			height: 26px;
			color: #ffffff;
			background: #006170;
			text-align: center;
			line-height: 26px;
			float: left;
			cursor: pointer;
			margin-right: 40px;
			margin-left: 20px;
		}

		.copy {
			width: 120px;
			height: 24px;
			color: #666666;
			background: #f0f4f5;
			text-align: center;
			line-height: 24px;
			float: left;
			cursor: pointer;
			border: 1px solid #999999;
		}

		.link {
			width: 1080px;
			padding: 0 20px;
			height: 90px;
			margin-top: 40px;
			overflow: hidden;
			color: #999999;
			background: #f0f4f5;
			text-align: center;
			line-height: 90px;
			float: left;
			cursor: pointer;
			text-overflow: ellipsis;
			font-size: 18px;
			white-space: nowrap;
			text-align: left;
		}
	}

	.m-newDetail .right_tit {
		background: #006170;
		width: 100%;
		height: 50px;
		line-height: 50px;
		text-align: center;
		color: #fff;
		margin-bottom: 10px;
	}

	.m-newDetail .right_info {
		overflow: hidden;
	}

	.m-newDetail .right_info .wrap {
		overflow: hidden;
	}

	.m-newDetail .youDetail {
		display: flex;
		flex-direction: column;
		padding: 0 0 20px;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.m-newDetail .youDetail img {
		width: 100%;
		height: 150px;
	}

	.m-newDetail .youDetail span {
		margin-top: 20px;
		margin-left: 10px;
	}

	.m-newDetail .youDetail:last-child {
		border-bottom: none;
	}

	.m-newDetail .youDetailList {
		cursor: pointer;
		padding: 40px 10px 40px 10px;
		border-bottom: 1px solid #eee;

	}

	.m-newDetail .youDetailList:hover {
		background: #ebf3f5;
	}

	.m-newDetail .tit_span {
		display: block;
		margin-bottom: 10px;
		font-size: 14px;
		height: 60px;
		line-height: 30px;
		color: #333;
	}

	.m-newDetail .goDetailBtn {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		font-size: 14px;
		color: #999;
	}

	.m-newDetail .goDetailBtn span:last-child {
		width: 100px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		color: #fff;
		background: #006170;
		cursor: pointer;
	}

	.m-newDetail .more_btn {
		font-size: 14px;
		color: #666;
		height: 50px;
		line-height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ebf3f5;
		font-weight: bold;
		cursor: pointer;
		margin-top: 10px;
	}

	.m-newDetail .more_btn span {
		position: relative;
		top: -1px;
		background: url(~@/assets/img/arrows_gray.png) center no-repeat;
	}

	.m-newDetail .more_btn:hover {
		color: #ffffff;

	}


	.m-newDetail .more_btn:hover span {
		color: #ffffff;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}



	.m-newDetail .more_btn img {
		width: 20px;
		height: 20px;
	}

	.m-newDetail .more_btn span:nth-child(2) {
		padding: 0 10px;
	}

	.m-newDetail .el-divider {
		background-color: #000 !important;
	}

	.info_right {
		width: 230px;
	}
</style>

<style>
	textarea {
		border-radius: 0px !important;
	}
</style>
